import { getMegaraxPath } from "./getPath";
import { adminRedirects } from "./legacy/adminRedirects";
import { catalogRedirects } from "./legacy/catalogRedirects";
import { crmRedirects } from "./legacy/crmRedirects";
import { invoiceRedirects } from "./legacy/invoiceRedirects";
import { LegacyPathParams } from "./legacy/redirect";
import { loyaltyRedirects } from "./legacy/loyaltyRedirects";
import { MegaraxUri } from "./uri";

export const legacyRedirects = [
  ...adminRedirects,
  ...catalogRedirects,
  ...crmRedirects,
  ...invoiceRedirects,
  ...loyaltyRedirects,
];

const normalizePathname = (pathname: string) => {
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
};

const matchLegacyPath = (legacyPath: string, pathname: string): LegacyPathParams | undefined => {
  const legacySegments = legacyPath.split("/").filter((segment) => segment !== "");
  const pathSegments = pathname.split("/").filter((segment) => segment !== "");

  const isPrefixMatch = legacySegments[legacySegments.length - 1] === "*";
  const comparedSegments = isPrefixMatch ? legacySegments.slice(0, -1) : legacySegments;

  if (isPrefixMatch ? pathSegments.length < comparedSegments.length : pathSegments.length !== comparedSegments.length)
    return undefined;

  const params: LegacyPathParams = {};

  for (let i = 0; i < comparedSegments.length; i++) {
    const legacySegment = comparedSegments[i];
    const pathSegment = pathSegments[i];

    if (legacySegment.startsWith(":")) {
      params[legacySegment.slice(1)] = decodeURIComponent(pathSegment);
      continue;
    }

    if (legacySegment !== pathSegment) return undefined;
  }

  return params;
};

export const getLegacyRedirectUri = (pathname: string): MegaraxUri | undefined => {
  const normalizedPathname = normalizePathname(pathname);

  for (const legacyRedirect of legacyRedirects) {
    const params = matchLegacyPath(legacyRedirect.legacyPath, normalizedPathname);
    if (!params) continue;

    const uri = legacyRedirect.toUri(params);
    if (uri) return uri;
  }

  return undefined;
};

export const getLegacyRedirectPath = (pathname: string, search = ""): string | undefined => {
  const uri = getLegacyRedirectUri(pathname);
  if (!uri) return undefined;

  const path = getMegaraxPath(uri);
  if (path === normalizePathname(pathname)) return undefined;

  if (!search || path.includes("?")) return path;

  return `${path}${search.startsWith("?") ? search : `?${search}`}`;
};
